import React, { useState } from "react";
import { Form, Input, Button, message} from "antd";
import { useNavigate } from "react-router-dom";
import { checkTelegramUser } from "../services/api";
import "../styles/HomePage.css";

const HomePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);

    let { username } = values;
    username = username.trim().replace(/^@/, "");

    try {
      const response = await checkTelegramUser(username);

      if (response.success) {
        // Делаем небольшую искусственную задержку (1с), если нужно:
        await new Promise((resolve) => setTimeout(resolve, 1000));

        navigate("/subscriptions", { state: { user: response.user } });
      }
    } catch (error) {
      message.error(error || "Ошибка при проверке пользователя");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-page-container">
      <div className="gray-container">
        <div className="white-container">
          <Form
            name="username_form"
            onFinish={handleFinish}
            layout="vertical"
            className="form-container"
          >
            <Form.Item
              label="username"
              name="username"
              rules={[{ required: true, message: "Введи Telegram username" }]}
            >
              <Input placeholder="Введите ваш Telegram username" />
            </Form.Item>
          </Form>
        </div>
        <Button
          type="primary"
          htmlType="submit"
          form="username_form"
          className="next-button"
          loading={loading}
        >
          {loading ? "Проверка..." : "Далее"}
        </Button>
      </div>
    </div>
  );
};

export default HomePage;
